import app from 'flarum/forum/app';
let homePromise = null;
export const portalUrl = function (section, params) {
  if (section === void 0) {
    section = 'home';
  }
  if (params === void 0) {
    params = {};
  }
  const base = `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/portal`;
  const query = new URLSearchParams({
    section,
    ...Object.fromEntries(Object.entries(params).map(_ref => {
      let [key, value] = _ref;
      return [key, String(value)];
    }))
  });
  return `${base}?${query}`;
};
export const portalHome = () => {
  if (!homePromise) homePromise = app.request({
    method: 'GET',
    url: portalUrl()
  }).catch(() => ({
    announcements: [],
    socials: [],
    partners: [],
    team: [],
    roles: []
  }));
  return homePromise;
};
export const portalEvent = body => app.request({
  method: 'POST',
  url: `${String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '')}/nova/portal/event`,
  body
});
flarum.reg.add('novatruck-theme', 'forum/components/portalApi', { portalUrl: portalUrl,portalHome: portalHome,portalEvent: portalEvent, });